import {useHistory} from "react-router-dom";
import './DiscoverMore.css'
import persistToggleMenu from "../../View/Navbar/persistToggleMenu";
//comment test

const DiscoverMore = (props) => {
    const hist = useHistory()
    const onClick = ()=> {
        if (props.url.startsWith('/')) {
            //to move to different page
            hist.push(props.url)
        }
        else if (props.url.startsWith('https')){
            //to move to different website
            window.open(props.url)
        }
        else {
            //Click to move on same page
            const container = document.querySelector(props.url)
            const padding = 150
            const position = container.getBoundingClientRect().top - padding
            window.scrollTo({top: position, left: 0, behavior: "smooth"})
        }
        persistToggleMenu()
    }

    return (
        <div className = 'discover-more-btn' onClick={onClick}> {props.name} </div>
    )
}
export default DiscoverMore;